import { Button,Box,Text } from "@pancakeswap/uikit";
import styled, { keyframes } from "styled-components";
import CompositeImage, { CompositeImageProps } from '../CompositeImage'

interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}
export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
  images: CompositeImageProps
  styles?: {
    heading: string;
    body: string;
    primaryButton: string;
    secondaryButton: string;
  };
}
const Container = styled.div`
margin-bottom: -50px;
  ${({ theme }) => theme.mediaQueries.md} {
    margin-bottom: 0px;
`;
const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;
const hoverEffect = keyframes`
  0% { transform: scale(1); }
  100% { transform: scale(1.1); }
`;
const hoverEffectText = keyframes`
  0% { transform: translateY(0); }
  100% { transform: translateY(-5px); }
`;
const borderAnimation = keyframes`
  0% {
    border-color: #f6c944 #f6c944 #88aaf1 #88aaf1; /* Start with Neon Gold and Neon Blue */
  }
  25% {
    border-color: #f6c944 #88aaf1 #88aaf1 #f6c944; /* Neon Gold and Neon Blue swap sides */
  }
  50% {
    border-color: #88aaf1 #88aaf1 #f6c944 #f6c944; /* Neon Blue and Neon Gold swap sides */
  }
  75% {
    border-color: #88aaf1 #f6c944 #f6c944 #88aaf1; /* Swap sides again, keeping the alternating pattern */
  }
  100% {
    border-color: #f6c944 #f6c944 #88aaf1 #88aaf1; /* Return to the original pattern */
  }
`;
const glowEffect = keyframes`
  0% {
    box-shadow: 
      0 -2px 3px rgba(136, 170, 241, 0.8),  /* Neon Blue glow at the top */
      0 2px 3px rgba(246, 201, 68, 0.8),  /* Neon Gold glow at the bottom */
      -2px 0 3px rgba(246, 201, 68, 0.8),  /* Neon Gold glow on the left */
      2px 0 3px rgba(136, 170, 241, 0.8);  /* Neon Blue glow on the right */
  }
  25% {
    box-shadow: 
      0 -3px 4px rgba(136, 170, 241, 1),  /* Neon Blue stronger at the top */
      0 3px 4px rgba(246, 201, 68, 1),  /* Neon Gold stronger at the bottom */
      -3px 0 4px rgba(246, 201, 68, 1),  /* Neon Gold stronger on the left */
      3px 0 4px rgba(136, 170, 241, 1);  /* Neon Blue stronger on the right */
  }
  50% {
    box-shadow: 
      0 -4px 6px rgba(136, 170, 241, 1),  /* Neon Blue stronger at the top */
      0 4px 6px rgba(246, 201, 68, 1),  /* Neon Gold stronger at the bottom */
      -4px 0 6px rgba(246, 201, 68, 1),  /* Neon Gold stronger on the left */
      4px 0 6px rgba(136, 170, 241, 1);  /* Neon Blue stronger on the right */
  }
  75% {
    box-shadow: 
      0 -3px 4px rgba(136, 170, 241, 1),  /* Neon Blue stronger at the top */
      0 3px 4px rgba(246, 201, 68, 1),  /* Neon Gold stronger at the bottom */
      -3px 0 4px rgba(246, 201, 68, 1),  /* Neon Gold stronger on the left */
      3px 0 4px rgba(136, 170, 241, 1);  /* Neon Blue stronger on the right */
  }
  100% {
    box-shadow: 
      0 -2px 3px rgba(136, 170, 241, 0.8),  /* Neon Blue glow at the top */
      0 2px 3px rgba(246, 201, 68, 0.8),  /* Neon Gold glow at the bottom */
      -2px 0 3px rgba(246, 201, 68, 0.8),  /* Neon Gold glow on the left */
      2px 0 3px rgba(136, 170, 241, 0.8);  /* Neon Blue glow on the right */
  }
`;


const ScrollBox = styled(Box)`
  width: 220px;
  border: 1px solid transparent; /* Transparent border to allow the background effect */
  border-radius: 10px;
   background-position: 0% 50%; /* Start from the left side */
  animation:  ${glowEffect} 3s ease-in-out infinite; /* Adding both border and glow animation */
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  
 

  ${({ theme }) => theme.mediaQueries.md} {
    width: 220px;
  }
`;
const AnimatedText = styled(Text)`
  text-align: left;
  font-size: 2em;
  color: ${({ color }) => color || '#ffffff'};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  font-family: 'Rajdhani', sans-serif;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 2em;
  }

  &:hover {
    animation: ${hoverEffectText} 0.4s ease forwards;
  }
`;

const colorChange = keyframes`
  0% {
    color: #ffffff;
  }
  100% {
    color: #f6c944;
  }
`;
const word1 = keyframes`
  0%, 100% {
    color: #ffffff;
  }
  25% {
    color: #f6c944;
  }
`;

const word2 = keyframes`
  0%, 100% {
    color: #ffffff;
  }
  50% {
    color: #f6c944;
  }
`;

const word3 = keyframes`
  0%, 100% {
    color: #ffffff;
  }
  75% {
    color: #f6c944;
  }
`;
interface WordProps {
  isHighlighted: boolean;
}
 
const Word = styled.span<WordProps>`
  color: #ffffff; // Alapértelmezett szín fehér
  font-family: 'Rajdhani', sans-serif;
  line-height: 1;
  ${({ isHighlighted }) => isHighlighted && 'color: #f6c944;'} // Arany szín az adott szavaknál

  &:hover {
    animation: ${hoverEffectText} 0.4s ease forwards;
  }
`;

const HeadingText = styled.div`
  font-size: 2.5em; // Nagyobb betűméret az első sorhoz
  color: #ffffff; // Kezdő szín fehér
  font-family: 'Rajdhani', sans-serif;
  margin-bottom: 0.5em;
  font-weight: bold; // Vastagabb betű
  line-height: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 0.2em;

  span:not(:nth-child(1)):not(:nth-child(10)):not(:nth-child(11)):not(:nth-child(12)) {
    color: #ffffff;
  }

  &:hover {
    animation: ${hoverEffectText} 0.4s ease forwards;
  }
`;


const SubHeadingText = styled(AnimatedText)`
  font-size: 1.2em; // Kisebb betűméret a többi szöveghez
  color: #ffffff; // Fehér szín a többi szöveghez 
  font-family: 'Rajdhani', sans-serif;
  line-height: 1.2;
  margin-bottom: 1em;

  &:hover {
    animation: ${hoverEffectText} 0.4s ease forwards;
  }
`;


const ButtonPro = styled(Button)`
  background: #000000; /* Fekete háttérszín */
  color: #ffffff; 
  border: 2px solid #62d5a3; /* Zöld szegély */
  border-radius: 6px; /* Enyhe kerekítés */
  padding: 14px 28px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-transform: uppercase; /* Nagybetűs szöveg */
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1; /* Gomb feletti elem */

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: #f6c944; /* Zöld háttérszín */
    transition: left 0.3s ease;
    z-index: 0; /* Háttér szín */
  }

  &:hover {
    color: transparent; /* Szöveg eltüntetése hover állapotban */
    background: #f6c944; /* Gomb háttérszín változás */
    border-color: #f6c944; /* Zöld szegély változás */
  }

  &:hover:before {
    left: 0; /* Zöld háttér kitöltése jobbra tolódáskor */
  }

  &:active {
    background: #1b5e20; /* Nyomás szín */
    transform: scale(0.98);
  }

  span {
    position: relative;
    z-index: 1; /* Szöveg a háttér felett */
  }

  /* Helyettesítő szöveg a hover állapotban */
  &::after {
    content: 'GO'; /* Helyettesítő szöveg */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    transition: opacity 0.3s ease;
    opacity: 0; /* Alapértelmezett rejtett állapot */
    z-index: 1;
  } 

  &:hover::after {
    opacity: 1; /* Helyettesítő szöveg megjelenítése hover állapotban */
  }
`;


const ImageWrapper = styled.div`
 margin-right: 5px;
 	  animation: ${fadeIn} 1s ease-out forwards;
${({ theme }) => theme.mediaQueries.md} {
   margin-right: 5px;
	  animation: ${fadeIn} 1s ease-out forwards;
`;
const ButtonText = styled(Text)`
display: none;
${({ theme }) => theme.mediaQueries.xs} {
  display: block;
`;

export { ButtonText, ImageWrapper, ButtonPro,SubHeadingText, HeadingText, Word,colorChange, word1, word2, word3, ScrollBox, Container };
